var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typing-text",style:(("width: " + _vm.width + "; height: " + _vm.height))},[_vm._v("\n  "+_vm._s(_vm.content)+"\n  "),_c('div',{staticClass:"caret"})])}
var staticRenderFns = []

export { render, staticRenderFns }